"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToCartSuccess = exports.addToCart = exports.fetchCartSuccess = exports.fetchCart = exports.ADD_TO_CART_SUCCESS = exports.ADD_TO_CART = exports.FETCH_CART_SUCCESS = exports.FETCH_CART = void 0;

var _array = require("lodash/array");

var _api = require("@modules/api");

var _snackbar = require("@modules/snackbar");

var _state = require("./state");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@cart';
var FETCH_CART = "".concat(ROOT, "/FETCH_CART");
exports.FETCH_CART = FETCH_CART;
var FETCH_CART_SUCCESS = "".concat(ROOT, "/FETCH_CART_SUCCESS");
exports.FETCH_CART_SUCCESS = FETCH_CART_SUCCESS;
var ADD_TO_CART = "".concat(ROOT, "/ADD_TO_CART");
exports.ADD_TO_CART = ADD_TO_CART;
var ADD_TO_CART_SUCCESS = "".concat(ROOT, "/ADD_TO_CART_SUCCESS");
exports.ADD_TO_CART_SUCCESS = ADD_TO_CART_SUCCESS;

var fetchCart = function fetchCart() {
  var _next;

  var cartID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var persist = arguments.length > 1 ? arguments[1] : undefined;
  var route = (0, _array.compact)(['/carts', cartID]).join('/');
  var query = persist ? "?persist=".concat(persist) : '';
  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_CART,
    route: "".concat(route).concat(query),
    schema: _state.transformCart,
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, fetchCartSuccess), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, function (_ref) {
      var error = _ref.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next)
  };
};

exports.fetchCart = fetchCart;

var fetchCartSuccess = function fetchCartSuccess(cart) {
  return {
    type: FETCH_CART_SUCCESS,
    cart: cart
  };
};

exports.fetchCartSuccess = fetchCartSuccess;

var addToCart = function addToCart(productID, cartID, quantity) {
  return {
    type: ADD_TO_CART,
    productID: productID,
    cartID: cartID,
    quantity: quantity
  };
};

exports.addToCart = addToCart;

var addToCartSuccess = function addToCartSuccess(cart, productID) {
  return {
    type: ADD_TO_CART_SUCCESS,
    cart: cart,
    productID: productID
  };
};

exports.addToCartSuccess = addToCartSuccess;